import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { createFoundingTask, fetchFoundingTasks, updateFoundingTask } from "../../../../services/automapFoundingDealerApi";
import { FoundingShell } from "./AdminFoundingShared";

export default function AdminFoundingTasksPage() {
  const [tasks, setTasks] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ dealerId: "", title: "", taskType: "follow_up", priority: "medium" });

  const load = () => {
    setLoading(true);
    const params = statusFilter ? { status: statusFilter } : {};
    fetchFoundingTasks(params)
      .then((data) => setTasks(data.tasks || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, [statusFilter]);

  const addTask = async () => {
    await createFoundingTask(form);
    setForm({ dealerId: "", title: "", taskType: "follow_up", priority: "medium" });
    load();
  };

  const completeTask = async (taskId) => {
    await updateFoundingTask(taskId, { status: "completed" });
    load();
  };

  return (
    <FoundingShell active="tasks" title="Tareas de onboarding" description="Seguimiento operativo por dealer fundador.">
      <div className="dealer-inventory-toolbar">
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">Todos los estados</option>
          <option value="open">Abiertas</option>
          <option value="in_progress">En progreso</option>
          <option value="waiting_on_dealer">Esperando dealer</option>
          <option value="completed">Completadas</option>
        </select>
      </div>
      <section className="dealer-state-box">
        <h3>Nueva tarea</h3>
        <div style={{ display: "grid", gap: "0.5rem", maxWidth: 480 }}>
          <input placeholder="Dealer ID" value={form.dealerId} onChange={(e) => setForm({ ...form, dealerId: e.target.value })} />
          <input placeholder="Título" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <button type="button" className="dealer-portal-btn" onClick={addTask} disabled={!form.dealerId || !form.title}>
            Crear tarea
          </button>
        </div>
      </section>
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading ? (
        <section className="dealer-state-box">
          <table className="dealer-inventory-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Dealer</th>
                <th>Tipo</th>
                <th>Estado</th>
                <th>Prioridad</th>
                <th>Vence</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tasks.map((task) => (
                <tr key={task.id}>
                  <td>{task.title}</td>
                  <td>
                    <Link to={`/admin/dealers/${task.dealerId}`}>{task.dealerId.slice(0, 8)}…</Link>
                  </td>
                  <td>{task.taskType}</td>
                  <td>{task.status}</td>
                  <td>{task.priority}</td>
                  <td>{task.dueAt ? new Date(task.dueAt).toLocaleDateString("es-CO") : "—"}</td>
                  <td>
                    {task.status !== "completed" ? (
                      <button type="button" className="admin-link" onClick={() => completeTask(task.id)}>
                        Completar
                      </button>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ) : null}
    </FoundingShell>
  );
}
